import { combineReducers } from 'redux';

import CurrentUserReducer from 'Store/Reducers/User/CurrentUserReducer';
import EnvironmentReducer from 'Store/Reducers/Environment/EnvironmentReducer';
import LoadingReducer from 'Store/Reducers/Loading/LoadingReducer';
import MasterDataReducer from 'Store/Reducers/MasterData/MasterDataReducer';
import SettingReducer from 'Store/Reducers/Setting/SettingReducer';

export default combineReducers({
  currentUser: CurrentUserReducer,
  environment: EnvironmentReducer,
  masterData: MasterDataReducer,
  settings: SettingReducer,
  loader: LoadingReducer,
});
